import { AnswerOption } from '@shared/components/question-box/question-box.component';
import { CallidusBoatCountryRegistered, CallidusBoatCountryRegisteredTranslocoMap, Country, CountryTranslocoMap } from '@backend/models';

/*
*Options for CountryRegistered, used by BVS
 */
export const countryRegisteredAnswerOptions: AnswerOption<CallidusBoatCountryRegistered> [] = [
  {
    title: CallidusBoatCountryRegisteredTranslocoMap[CallidusBoatCountryRegistered.Aut],
    id: CallidusBoatCountryRegistered.Aut,
    value: CallidusBoatCountryRegistered.Aut
  },
  {
    title: CallidusBoatCountryRegisteredTranslocoMap[CallidusBoatCountryRegistered.Ger],
    id: CallidusBoatCountryRegistered.Ger,
    value: CallidusBoatCountryRegistered.Ger
  },
  {
    title: CallidusBoatCountryRegisteredTranslocoMap[CallidusBoatCountryRegistered.Cro],
    id: CallidusBoatCountryRegistered.Cro,
    value: CallidusBoatCountryRegistered.Cro
  },
  {
    title: CallidusBoatCountryRegisteredTranslocoMap[CallidusBoatCountryRegistered.Slo],
    id: CallidusBoatCountryRegistered.Slo,
    value: CallidusBoatCountryRegistered.Slo
  }
];

/*
*Options for Country, used in the person adress
 */
export const countryAnswerOptions: AnswerOption<Country> [] = [
  {
    title: CountryTranslocoMap[Country.Austria],
    id: Country.Austria,
    value: Country.Austria
  },
  {
    title: CountryTranslocoMap[Country.Germany],
    id: Country.Germany,
    value: Country.Germany
  },
  {
    title: CountryTranslocoMap[Country.Croatia],
    id: Country.Croatia,
    value: Country.Croatia
  },
  {
    title: CountryTranslocoMap[Country.Slovenia],
    id: Country.Slovenia,
    value: Country.Slovenia
  }
];